'use client';

import { useSetAtom } from 'jotai';
import { installmentCollapsed } from '@packages/modules/src/atoms';
import { IconInstallmentsAndLegalHints } from '../layouts/IconInstallmentsAndLegalHints/IconInstallmentsAndLegalHints.client';

export type InstallmentCalculatorInCardProps = {
  /**
   * the single installment value from the calculation result as Integer (e.g. 1337)
   */
  singleInstallment: number;
  /**
   * the currency string from the calculation result
   */
  currency: string;
  /**
   * the calulator ID auf the card element
   */
  calculatorID: string;
};

/**
 * Promotion component Layout 1
 *
 * component to promote the installment calculator in layout version 1
 *
 * */
export const InstallmentCalculatorInCard = ({
  singleInstallment,
  currency,
  calculatorID,
}: InstallmentCalculatorInCardProps) => {
  const setCollapsed = useSetAtom(installmentCollapsed);

  const handleAction = () => {
    setCollapsed(false);
    document.getElementById(calculatorID)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  return (
    <IconInstallmentsAndLegalHints
      singleInstallment={singleInstallment}
      currency={currency}
      openInstallmentCalculatorHandler={() => handleAction()}
    />
  );
};
